<h3 mat-dialog-title tabindex="0" class="semi-bold">{{ title | translate }}</h3>
<div mat-dialog-content>
  @if (!historyDataSource.results.length) {
    <app-no-data [message]="'App.StatusHistory.Messages.NoHistory' | translate"></app-no-data>
  } @else {
  <!-- Standard data table when no refund column -->
  <app-data-table
    *ngIf="!showRefundColumn"
    [dataSource]="historyDataSource"
    [displayedColumns]="historyColumns"
    [statusClickable]="false"
    [withPagination]="false"
  ></app-data-table>

  <!-- Custom table with refund column for payment history -->
  <div class="responsive-table" *ngIf="showRefundColumn">
    <table mat-table class="table-striped payment-history-table mb--sm" [dataSource]="historyDataSource.results">
      <ng-container *ngFor="let col of historyColumns | keyvalue" [matColumnDef]="col.key">
        <th mat-header-cell *matHeaderCellDef>{{ col.value.label | translate }}</th>
        <td mat-cell *matCellDef="let row">
          {{ row[col.key] | customFormat: col.value.format }}
        </td>
      </ng-container>
      
      <!-- Refund Column -->
      <ng-container matColumnDef="refund">
        <th mat-header-cell *matHeaderCellDef class="align-center">{{ 'App.Admin.Customer.Labels.Refund' | translate }}</th>
        <td mat-cell *matCellDef="let row" class="align-center">
          <button 
            *ngIf="row.eligibleForRefund && !row.isRefunded"
            mat-button 
            class="primary-button mini-button"
            [disabled]="isRefunding"
            (click)="handleRefund(row)">
            @if (refundingChargeId === row.chargeId) {
              <mat-spinner class="secondary-spinner" diameter="20"></mat-spinner>
            } @else {
              {{ 'App.Admin.Customer.Buttons.Refund' | translate }}
            }
          </button>
          <span *ngIf="row.isRefunded" class="color--success semi-bold">
            {{ 'App.Admin.Customer.Labels.Refunded' | translate }}
          </span>
          <span *ngIf="!row.eligibleForRefund && !row.isRefunded">—</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getColumnsWithRefund()"></tr>
      <tr mat-row *matRowDef="let row; columns: getColumnsWithRefund()"></tr>
    </table>
  </div>
  }
</div>
<div mat-dialog-actions>
  <div class="row column--12 justify-content-center">
      <button mat-button class="secondary-button rounded" (click)="closeDialog()">
        {{ 'App.StatusHistory.Labels.Close' | translate }}
      </button>
  </div>
</div>
